import React from 'react';
import { RouterProvider, RouteObject, createBrowserRouter } from 'react-router-dom';

import { Routes, Route } from '@routes';

const getRoutes = (routes: Route[]): RouteObject[] => {
	let data: RouteObject[] = [];
	for(let route of routes) {
		data.push(route);
	}
	return data;
}

export const PageRouter: React.FunctionComponent = () => {
	const routes = getRoutes(Routes);
	return <RouterProvider router={createBrowserRouter(routes)} />
}

export default PageRouter;
